import { render, staticRenderFns } from "./SettingsMembers.vue?vue&type=template&id=60572a57&scoped=true"
import script from "./SettingsMembers.vue?vue&type=script&lang=js"
export * from "./SettingsMembers.vue?vue&type=script&lang=js"
import style0 from "./SettingsMembers.vue?vue&type=style&index=0&id=60572a57&prod&scoped=true&lang=css"
import style1 from "./SettingsMembers.vue?vue&type=style&index=1&id=60572a57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60572a57",
  null
  
)

export default component.exports